import React from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import {
    addSelectedLayer,
    removeSelectedLayer
} from '../../../../redux/panel/print/Actions';
import {
    setActiveLayerPrintable
} from '../../../../redux/active_layers/Actions';
import withStyles from '@material-ui/core/styles/withStyles';
import { TextField, Typography, FormControlLabel, Checkbox, Collapse } from '@material-ui/core';
import EditLayer from './EditLayer';
import EditIcon from '@material-ui/icons/Edit';
import { MAIN_MAP } from '../../../../redux/map/Constants';

class Layers extends React.Component {
    constructor (props) {
        super(props);
        this.state = {
            editLayerOpen: false,
            selectedLayers: [...this.props.activeLayers]
        };
    }

    render () {
        const {
            classes,
            redLineBoundaryVisible,
            setRedLineBoundaryVisible,
            mySiteCardsVisible,
            setMySiteCardsVisible,
            renderMap,
            // Redux State
            activeLayers,
            // selectedLayers,
            layers,
            highlights,
            selectedDrawnFeatures,
            areSiteCardsVisible,
            numSiteCards,
            // Redux Dispatch
            dispatchAddSelectedLayer,
            dispatchRemoveSelectedLayer,
            dispatchSetActiveLayerPrintable

        } = this.props;
        const { editLayerOpen, selectedLayers } = this.state;
        const selectedHighlight = highlights.highlightedFeatures.find(f => f.key.includes('_selected')) ?
            highlights.highlightedFeatures.find(f => f.key.includes('_selected')) : null;
        return (
            <>
                <div className={classes.layerDropdownList}>
                    { (selectedDrawnFeatures.length > 0 || !_.isEmpty(selectedHighlight)) && (
                        <div className={classes.layerDropdownRow}>
                            <div className={classes.layerDropdownItemTitle}>
                                <Typography
                                    variant="subtitle2"
                                    className={classes.layerName}
                                >
                                    Red Line Boundary
                                </Typography>
                            </div>
                            <div className={classes.layerDropdownItemCheckbox}>
                                <Checkbox
                                    checked={redLineBoundaryVisible}
                                    onChange={(e, checked) => {
                                        setRedLineBoundaryVisible(checked);
                                    }}
                                />
                            </div>
                        </div>
                    )}
                    { (areSiteCardsVisible && numSiteCards > 0) && (
                        <div className={classes.layerDropdownRow}>
                            <div className={classes.layerDropdownItemTitle}>
                                <Typography
                                    variant="subtitle2"
                                    className={classes.layerName}
                                >
                                    My Site Cards
                                </Typography>
                            </div>
                            <div className={classes.layerDropdownItemCheckbox}>
                                <Checkbox
                                    checked={mySiteCardsVisible}
                                    onChange={(e, checked) => {
                                        setMySiteCardsVisible(checked);
                                    }}
                                />
                            </div>
                        </div>
                    )}
                    {activeLayers.length > 0 ? activeLayers.filter((l) => l.visible).map((layer, i) => (
                        <React.Fragment key={i}>
                            <div className={classes.layerDropdownRow} key={i}>
                                <div>
                                    <Typography
                                        variant="subtitle2"
                                        className={classes.layerName}
                                    >
                                        {layers.find((l) => l.system_name === layer.uid).name}
                                    </Typography>
                                </div>
                                <div>
                                    <Checkbox
                                        checked={layer.printable}
                                        onChange={(e) => {
                                            dispatchSetActiveLayerPrintable(layer.uid, e.target.checked);
                                            renderMap();
                                        }}
                                    />
                                </div>
                            </div>
                        </React.Fragment>
                    )) : (
                        <div className={classes.layerDropdownRow}>
                            <Typography
                                variant="subtitle2"
                                className={classes.layerName}
                            >
                                No layers selected on the map
                            </Typography>
                        </div>
                    )}
                </div>
            </>
        );
    }
}

const style = theme => ({
    layerDropdownRow: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center'
        // paddingTop: '10px'
    },
    layerDropdownContainer: {
        padding: '10px 5px 0 5px'
    },
    layerDropdownList: {
        padding: '0 0 20px 0'
    },
    layerDropdownSubtitle: {
        paddingTop: '10px'
    },
    layerDropdownItemEdit: {
        cursor: 'pointer',
        color: theme.palette.background.contrastText
    },
    layerDropdownItemCheckbox: {
        display: 'flex',
        alignItems: 'center'
    },
    layerName: {
        fontSize: '12px',
        color: theme.palette.grey.variant5,
        fontWeight: 400
    }
});

const mapStateToProps = state => {
    return {
        activeLayers: state.activeLayers,
        layers: state.layers.layers,
        selectedLayers: state.print_panel.selectedLayers,
        selectedDrawnFeatures: state[MAIN_MAP].drawModule ? state[MAIN_MAP].drawModule.getDrawControl().getSelected().features : [],
        highlights: state.highlights,
        numSiteCards: state.project.currentProject.numSiteCards,
        areSiteCardsVisible: state.siteCard.areSiteCardsVisible
    };
};

const mapDispatchToProps = dispatch => ({
    dispatchAddSelectedLayer: (systemName) => dispatch(addSelectedLayer(systemName)),
    dispatchRemoveSelectedLayer: (systemName) => dispatch(removeSelectedLayer(systemName)),
    dispatchSetActiveLayerPrintable: (systemName, printable) => dispatch(setActiveLayerPrintable(systemName, printable))
});

export default compose(
    connect(mapStateToProps, mapDispatchToProps),
    withStyles(style)
)(Layers);